<template>
<div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CContainer>
      <CCol sm="12" class="justify-content-center m-0">
          <CCol sm="12" lg="12" class="mt-5">
            <CRow>
              <!-- Page Title -->
              <h3 class="text-center mt-4 text-black bold col-12">
                Student Quiz List
              </h3>

              <!-- Quiz List -->
              <div class="col-lg-12">
                <CRow>
                  <CCol>
                    <CCard v-if="!quizStudDetail.length">
                      <div class="mt-5 text-center mb-5">
                        <img src="../assets/img/nodata.png" width="120px" />
                        <br />
                        <br />
                        <span class="custom-font"> No quiz available yet</span>
                      </div>
                    </CCard>
                   
                   <div class="d-sm-down-none"> <br /><br /></div>

                    <CCard
                      v-for="item in quizStudDetail"
                      v-bind:key="item.subjectId"
                      style="border-radius: 20px"
                      class="box-shadow m-1"
                    >
                      <div
                        style="
                          border-top-right-radius: 10px;
                          border-top-left-radius: 10px;
                        "
                        class="bg-gradient-turqouise-no p-2"
                      >
                      <div class="row">
                        <div class="col-10">

                        <h6 class="custom-font mt-2 text-left ml-2">{{ item.Title }}</h6>
                        </div>
                        <div class="col-2" @click="GotoPageQuestionDescription(item.Id)">

                         <CLink
                            class="card-header-action btn-minimize mr-2"
                            @click="GotoPageQuestionDescription(item.Id)"
                            v-c-tooltip.hover.click="
                              'Click to view the Detail!'
                            "
                          >
                            <CIcon name="cil-arrow-thick-right" class="text-left text-white" @click="GotoPageQuestionDescription(item.Id)"/>
                          </CLink>
                        </div>
                      </div>
                      </div>
                      <div class="text-left ml-3">
                          <h6 class="custom-font mt-4">
                          Quiz Id: <strong>{{ item.Id }} </strong>
                        </h6>
                        <h6 class="custom-font">
                          Teacher Name: <strong>{{ item.TeacherName }} </strong>
                        </h6>
                        <h6 class="custom-font">
                           <span class="text-left">Subject: <strong> {{ item.subjectName }}</strong></span>
                        </h6>

                          <h6 class="custom-font">Grade:
                         <strong>  {{ item.gradeName }} </strong>
                        </h6>
                        <h6 class="custom-font">Question Amount:
                         <strong>  {{ item.questionCount }} </strong>
                        </h6>
                        <h6 class="custom-font">

                           Time:

                           
                        <strong> {{ item.TimerString }} </strong>
                        </h6>
                        <br />
                      </div>
                    </CCard>
                  </CCol>
                </CRow>
              </div>
            </CRow>
          </CCol>
      </CCol>
      </CContainer>
      <br /><br />
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data: function () {
    return {
      backgroundBanner,
      quizStudDetail: [],
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false,
    };
  },
  async mounted() {
    this.GetQuizStudDetails();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizStudDetails() {
      this.$API
        .get(
          this.$ListStudentQuizBySubjectId +
            "?studentId=" +
            this.$route.query.studentId +
            "&subjectId=" +
            this.$route.query.subjectId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quizStudDetail = response.data;
            console.log(this.quizStudDetail);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GotoPageQuestionDescription(quizId) {
      this.$router.push(
        "/QuizStudentDescription?quizId=" +
          quizId +
          "&studentId=" +
          this.$route.query.studentId +
          "&userId=" +
          this.$route.query.userId
      );
    },
  },
};
</script>